import { useEffect } from 'react'

const useInitialLoad = removeAllImage => {
  useEffect(() => () => {
    removeAllImage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useInitialLoad
